import React, { useState } from "react";
import headerLogo from "src/assets/images/shifara-green-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import twiterIcon from "src/assets/images/twitter-icon.png";
import instaicon from "src/assets/images/instagram-icon.png";
import youtubeicon from "src/assets/images/youtube-icon.png";
import facbookIcon from "src/assets/images/facebook-icon.png";
import tiktokIcon from "src/assets/images/tiktok-icon.png";
import linkdlnIcon from "src/assets/images/linkedin-icon.png";
import playstoreIcon from "src/assets/images/playstore-icon.png";
import appstoreIcon from "src/assets/images/app-store-icon.png";
import { Link } from "react-router-dom";
import TextLineSection from "./HomePage/TextLineSection";
import ComingSoonModal from "../Modals/ComingSoonModal";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { Loader2 } from "lucide-react";
import { validateEmail } from "src/helpers/helperFunctions";

const WebsiteFooter: React.FC = () => {
  const [clickedButton, setClickedButton] = useState<string>("");
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");

  const handleSubscribe = async () => {
    if (!email) {
      toast.error("Please enter your email");
      return;
    }
    if (!validateEmail(email)) {
      toast.error("Please enter a valid email");
      return;
    }
    setIsLoader(true);
    const { res, err } = await httpRequest<any>({
      method: "post",
      path: "/customer/newsletter",
      params: { email },
    });
    if (res) {
      toast.success("Subscribed successfully");
      setEmail("");
    } else {
      toast.error(err);
    }
    setIsLoader(false);
  };

  return (
    <>
      {clickedButton && (
        <ComingSoonModal
          clickedButton={clickedButton}
          handleClose={() => setClickedButton("")}
        />
      )}
      <TextLineSection text="Join now" className="!my-0" />
      <footer className="footer-section">
        <div className="view-area-width">
          <div className="footer-inner-grid">
            <div className="flex flex-col">
              <div className="xl:h-[80px] h-[60px]">
                <Link to="/">
                  <img alt="logo" className="header-logo" src={headerLogo} />
                </Link>
              </div>
              <p className="font-Lexend-Regular w-[80%] theme-color-green font-size-16px">
                Empower your health journey with our intuitive health tests
                designed for everyone. Discover actionable insights with a
                simple click and monitor your health trends no matter where you
                are. Begin a new chapter in personal health management and stay
                ahead with knowledge about what your body needs.
              </p>
            </div>
            <div className="flex justify-between w-full">
              <div className="flex flex-col">
                <div className="xl:h-[80px] h-[60px]">
                  <h2 className="font-Lexend-Bold font-size-40px theme-color-green">
                    Legal
                  </h2>
                </div>
                <div className="flex flex-col gap-3">
                  <Link
                    className="font-Lexend-Regular theme-color-green font-size-18px"
                    to={"/doctor/register"}
                  >
                    Join as a Doctor
                  </Link>
                  <Link
                    className="font-Lexend-Regular theme-color-green font-size-18px"
                    to={"/terms-conditions"}
                  >
                    Terms & Conditions
                  </Link>
                  <Link
                    className="font-Lexend-Regular theme-color-green font-size-18px"
                    to={"/privacy-policy"}
                  >
                    Privacy Policy
                  </Link>
                  <Link
                    className="font-Lexend-Regular theme-color-green font-size-18px"
                    to={"/faqs"}
                  >
                    FAQs
                  </Link>
                </div>
              </div>
              <div className="flex flex-col">
                <div className="xl:h-[80px] h-[60px]">
                  <h2 className="font-Lexend-Bold font-size-40px theme-color-green">
                    Contact
                  </h2>
                </div>
                <Link
                  className="font-Lexend-Regular flex items-center gap-2 theme-color-green font-size-18px"
                  to={"mailto:info@shifara.com"}
                >
                  <FontAwesomeIcon icon={faEnvelope} />
                  info@shifara.com
                </Link>
              </div>
              <div className="flex flex-col">
                <div className="xl:h-[80px] h-[60px]">
                  <h2 className="font-Lexend-Bold font-size-40px theme-color-green">
                    Social links
                  </h2>
                </div>
                <div className="social-icon">
                  <Link to={""}>
                    <img alt="" src={twiterIcon} />
                  </Link>
                  <Link to={""}>
                    <img alt="" src={youtubeicon} />
                  </Link>
                  <Link to={""}>
                    <img alt="" src={facbookIcon} />
                  </Link>
                  <Link to={""}>
                    <img alt="" src={instaicon} />
                  </Link>
                  <Link to={""}>
                    <img alt="" src={tiktokIcon} />
                  </Link>
                  <Link to={""}>
                    <img alt="" src={linkdlnIcon} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* <div className='footer-download'> */}
          <div className="w-full flex justify-end gap-6">
            {/* <div className="footer-download"> */}
              {/* <p className="font-Poppins-Regular theme-color-green mb-3 font-size-16px">
                Download Shifara app on
              </p> */}
              {/* <div className="flex justify-between"> */}
                <Link onClick={() => setClickedButton("playstore")} to={""}>
                  <img alt="" src={playstoreIcon} />
                </Link>
                <Link onClick={() => setClickedButton("appstore")} to={""}>
                  <img alt="" src={appstoreIcon} />
                </Link>
              {/* </div> */}
            {/* </div> */}
          </div>
          <div className="join-our-newsletter-main w-full">
            <h2 className="font-Lexend-Medium font-size-30px theme-color-green">
              Join our newsletter
            </h2>
            <div className="join-our-newsletter">
              <input
                placeholder="Enter your email"
                className="font-Poppins-Regular font-size-18px theme-color-green bg-transparent"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSubscribe();
                  }
                }}
              />
              <button
                className="subcribe-btn-green font-Poppins-SemiBold text-[#F3F4F4] font-size-18px"
                onClick={handleSubscribe}
              >
                Subscribe{" "}
                {isLoader ? (
                  <Loader2 size={16} className="animate-spin" />
                ) : (
                  <FontAwesomeIcon icon={faEnvelope} />
                )}
              </button>
            </div>
          </div>
          <span className="font-Lexend-Medium font-size-17px theme-color-green">
            © Copyright 2024 Shifara | All Rights Reserved{" "}
          </span>
        </div>
        <div className="Get-in-contact font-Suisse-Intl-SemiBold">
          <div className="marquee-subscriibe text-color-get-in-contact">
            <h2>Get in Contact</h2>
            <h2>Get in Contact</h2>
            <h2>Get in Contact</h2>
            <h2>Get in Contact</h2>
          </div>
        </div>
      </footer>
    </>
  );
};

export default WebsiteFooter;
